import img1 from '../assets/features/a.png';
import img2 from '../assets/features/ (2).png';
import img3 from '../assets/features/ (3).png';
import img4 from '../assets/features/ (4).png';
import img5 from '../assets/features/ (5).png';
import img6 from '../assets/features/ (6).png';


var FeatureData = [
    {
        img : img6,
        title : "Games",
        desc : "Play fun games & earn coins"
    },
    {
        img : img5,
        title : "Spin And Win",
        desc : "Spin & Win Upto 2x Coins"
    },
    {
        img : img2,
        title : "Videos",
        desc : "Watch Videos & Earn Coins"
    },
    {
        img : img4,
        title : "Earn Coins",
        desc : "Earn Upto 2x Coins"
    },
    {
        img : img3,
        title : "Refer And Earn",
        desc : "Refer A Friend & Earn Coins"
    },
    {
        img : img1,
        title : "Leader Board",
        desc : "Top Reward Winners Get Featured Here"
    },
];

export default FeatureData